import React, { useEffect, useState } from 'react';
import { Col, Form, FormInstance, Grid, Message, Row, Schema } from "rsuite";
import { getCitiesLookup } from '@/services/city.service';
import FetchingSelect from '@/components/FetchingSelect';
import { CityTypeStoryChapterTask, UpsertCityTypeStoryChapterTask } from '@/models/story-chapter-task.model';

const modelSchema = Schema.Model<UpsertCityTypeStoryChapterTask>({
  cityId: Schema.Types.NumberType().isRequired('This field is required.'),
});
const emptyModel: UpsertCityTypeStoryChapterTask = {
  cityId: undefined,
};

interface CityTypeTaskFormFormProps{
  formObject?: CityTypeStoryChapterTask;
  onFormChange: (formValue: any) => void;
  formRef: React.Ref<FormInstance<Record<string, any>>>;
  loading: number;
}

const CityTypeTaskForm: React.FC<CityTypeTaskFormFormProps> = ({ formObject, onFormChange, formRef, loading }) => {
  const [formValue, setFormValue] = useState<UpsertCityTypeStoryChapterTask>(emptyModel);
  
  useEffect(() => {
    if (formObject) {
      setFormValue(formObject);
    } else {
      setFormValue(emptyModel);
    }
  }, [formObject]);

  useEffect(() => {
    onFormChange(formValue);
  }, [formValue]);
  
  return (
    <Form name='upsert-city-task-type' fluid
        ref={formRef}
        formValue={formValue}
        model={modelSchema}
        disabled={!!loading}
    >    
      <Grid w='100%' fluid>
        <Row>
          <Col span={{xs:24, lg:12}}>
            <Form.Group controlId="cityId">
              <Form.Label>City</Form.Label>
              <Form.Control name="cityId" accepter={FetchingSelect} block
                fetchData={(text, page) => getCitiesLookup(text, undefined, page)} 
                placeholder="Select a City"
                value={formValue.cityId}
                onChange={val=> setFormValue(pre => ({...pre, cityId: val}))}
              />   
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Message showIcon type="info">
            User should run within a city. Amount: distance.
          </Message>
        </Row>         
      </Grid>
    </Form>
  );
};

export default CityTypeTaskForm;